module.exports = __webpack_public_path__ + "files/4070591d24c3593a5daf2b3acb362ec6.png";